import { combineReducers } from 'redux';

import { userConstants } from '../constants';
import profilePermissionReducer from './user/profilePermission';

const emailVerify = (
  state = {
    loading: false,
    resent: false,
  },
  action
) => {
  switch (action.type) {
    case userConstants.RESEND_VERI_REQUEST: {
      return {
        loading: true,
      };
    }
    case userConstants.RESEND_VERI_SUCCESS: {
      return {
        resent: true,
      };
    }
    case userConstants.RESEND_VERI_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

const sendResetPassword = (
  state = { loading: false, sent: false, prefix: undefined },
  action
) => {
  switch (action.type) {
    case userConstants.SEND_RESETPASS_REQUEST: {
      return {
        loading: true,
      };
    }
    case userConstants.SEND_RESETPASS_SUCCESS: {
      return {
        sent: true,
        prefix: action.prefix,
      };
    }
    case userConstants.SEND_RESETPASS_FAILURE: {
      return {
        error: action.error,
      };
    }

    case userConstants.SEND_RESETPASS_RESET: {
      return {};
    }

    default: {
      return state;
    }
  }
};

const resetPassword = (
  state = {
    loading: false,
    reset: false,
  },
  action
) => {
  switch (action.type) {
    case userConstants.RESETPASS_REQUEST: {
      return {
        loading: true,
      };
    }
    case userConstants.RESETPASS_SUCCESS: {
      return {
        reset: true,
      };
    }
    case userConstants.RESETPASS_FAILURE: {
      return {
        error: action.error,
      };
    }

    case userConstants.RESETPASS_RESET: {
      return {};
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  emailVerify,
  sendResetPassword,
  resetPassword,
  profilePermission: profilePermissionReducer,
});
